import script from "./QuestionContent.vue?vue&type=script&setup=true&lang=js"
export * from "./QuestionContent.vue?vue&type=script&setup=true&lang=js"

import "./QuestionContent.vue?vue&type=style&index=0&id=b4935e6c&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b4935e6c"]])

export default __exports__